import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnDestroy, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'ubs-cms',
  templateUrl:'./cms.component.html',
  styles: [
    `.monkey {
      background-color:blue;
      padding:3rem;
    }`
  ],
})
export class CmsComponent {

  constructor() {}

}
